import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ios-pwa-prompt',
  templateUrl: './ios-pwa-prompt.component.html',
  styleUrls: ['./ios-pwa-prompt.component.scss'],
})
export class IosPwaPromptComponent implements OnInit {
  public isSafari = true;

  constructor(private modalController: ModalController, public translate: TranslateModule) {}

  ngOnInit() {
    this.detectBrowser();
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
    document.cookie = 'pwaDismissed=true; max-age=86400; path=/;';
  }

  // TODO: Use a better future-proof method to detect browsers
  detectBrowser() {
    this.isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  }
}
